import { render } from "./template.vue?vue&type=template&id=6b670b5d&scoped=true"
import script from "./index.ts?vue&type=script&lang=js&external"
export * from "./index.ts?vue&type=script&lang=js&external"

import "./template.vue?vue&type=style&index=0&id=6b670b5d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b670b5d"]])

export default __exports__